import React from "react";
import NavBar from "./components/NavBar";

export default function DocsHome() {
  return (
    <div>
      <NavBar />
    </div>
  );
}
